import { mergeClassNames } from '../../style';
import { PrimaryButton, PrimaryButtonProps, SecondaryButton, SecondaryButtonProps } from './button';

export const SmallPrimaryButton = ({ children, ...restProps }: PrimaryButtonProps) => {
  const className = mergeClassNames([
    { className: 'core-small-button__button' },
    { className: restProps.className ?? '' },
  ]);
  return (
    <PrimaryButton {...restProps} className={className}>
      {children}
    </PrimaryButton>
  );
};

export const SmallSecondaryButton = ({ children, ...restProps }: SecondaryButtonProps) => {
  const className = mergeClassNames([
    { className: 'core-small-button__button' },
    { className: restProps.className ?? '' },
  ]);
  return (
    <SecondaryButton {...restProps} className={className}>
      {children}
    </SecondaryButton>
  );
};
